<template>
    <div>
        <transition-group
            tag="div"
            name="files-animation"
            class="files-new-view"
            :class="{ 'files-new-view__short': shortFile, 'files-new-view__small': small }"
        >
            <template v-for="file in files">
                <FileNewView
                    v-if="!filesImage.includes(file)"
                    class="files-new-view-item"
                    :key="file.uuid"
                    :file="files.find(f => f.uuid === file.uuid)"
                    :parent="parent"
                    :listFile="listFile"
                    :allow-preview-settings="allowPreviewSettings"
                    :shortFile="shortFile"
                    @save="$emit('save')"
                    @file:delete="openRemoveModal"
                />
                <ImageNewView
                    v-if="filesImage.includes(file)"
                    class="files-new-view-item"
                    :key="file.uuid"
                    :file="files.find(f => f.uuid === file.uuid)"
                    :parent="parent"
                    :listFile="listFile"
                    :shortFile="shortFile"
                    @file:delete="openRemoveModal"
                />
            </template>
        </transition-group>
        <FilePreview
            class="mt-20"
            :key="index"
            v-for="(document, index) in documents"
            :file="files.find(f => f.uuid === document.uuid)"
        />
    </div>
</template>

<script>
import axios from "~axios"
import FilePreview from "@components/Files/FilePreview.vue"
import FileNewView from "@components/Files/FileNewView.vue"
import ImageNewView from "@components/Files/ImageNewView.vue"
//
export default {
    name: "FilesNewView",
    components: {
        FilePreview,
        ImageNewView,
        FileNewView
    },
    props: {
        allowPreviewSettings: {
            type: Boolean,
            default: true
        },
        files: {
            type: Array,
            default: () => []
        },
        shortFile: {
            type: Boolean,
            default: false
        },
        forcePreview: {
            type: Boolean,
            default: false
        },
        listFile: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        updatePreview: {
            type: Boolean,
            default: true
        },
        parent: {
            type: String,
            default: "" // => "lesson"
        }
    },
    created() {
        if (this.updatePreview) {
            let checkStatus = setInterval(() => {
                for (const [index, file] of this.files.entries()) {
                    const { uuid, url } = file
                    if (!url) {
                        axios.get(`/files/${uuid}`).then(response => {
                            let data = response.data.data
                            if (data.process_status === "completed" && !data.url.includes("fileservice")) {
                                this.files[index] = {
                                    ...this.files[index],
                                    url: data.url
                                }
                                this.$forceUpdate()
                                this.$emit("save")
                            }
                        })
                    }
                }
                if (this.files.filter(f => f.url).length === this.files.length) {
                    clearInterval(checkStatus)
                    this.$forceUpdate()
                }
            }, 2000)
        }
    },
    methods: {
        openRemoveModal(file) {
            this.$emit("openRemoveModal", file)
            this.$emit("delete", file)
        },
        isImageFile(file) {
            /* if (this.shortFile) {
                return false
            }*/

            const validMimeTypes = [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/webp",
                "image/svg+xml",
                "image/apng",
                "image/x-icon",
                "image/bmp"
            ]

            return validMimeTypes.includes(file.mime_type)
        }
    },
    computed: {
        documents() {
            const allowPreview = file =>
                this.forcePreview ||
                ((file.allow_doc_preview || (file.pivot && file.pivot.allow_doc_preview)) && this.parent !== "expert")
            return this.files.filter(
                file =>
                    (file.mime_type.includes("application/pdf") ||
                        file.extension === "doc" ||
                        file.extension === "ppt" ||
                        file.extension === "pptx" ||
                        file.extension === "docx") &&
                    allowPreview(file)
            )
        },
        filesList() {
            return this.files.filter(f => !this.isImageFile(f))
        },
        filesImage() {
            return this.files.filter(f => this.isImageFile(f))
            /*return this.files.filter(f => f.mime_type.match("image"))*/
        }
    }
}
</script>

<style scoped lang="sass">
.files-animation-move
    transition: transform .2s
.files-new-view-item
    transition: all .2s
.files-animation-enter, .files-animation-leave-to
    opacity: 0
    transform: translateY(-10px)
.files-animation-leave-active
    position: absolute

.files-new-view
    display: flex
    align-items: self-start
    flex-wrap: wrap
    width: 100%
    gap: 10px
    transition: .2s
    &::v-deep
       .spin-loader
           display: block !important
    &__small
        &::v-deep
            .image-new-view__wrapper
                max-width: 30px
                height: auto
</style>
